import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("dsa_admin_token", data.token);
      toast.success("Bienvenue");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Connexion échouée");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#050505] flex items-center justify-center px-6"
      style={{
        backgroundImage:
          "radial-gradient(ellipse at top, rgba(212,175,55,0.08), transparent 60%)",
      }}
    >
      <form
        onSubmit={submit}
        className="w-full max-w-md bg-[#0d0d0d] border border-white/10 p-10 relative"
      >
        <div className="flex items-center justify-center gap-3">
          <img src="/assets/logo.png" alt="" className="h-14 w-14 object-contain" />
        </div>
        <div className="text-center mt-4">
          <div className="text-xs tracking-[0.5em] gold uppercase">Espace privé</div>
          <h1 className="mt-2 font-serif text-white text-3xl">Administration</h1>
        </div>

        <div className="mt-8 space-y-5">
          <label className="block">
            <div className="text-[11px] font-semibold text-gray-400 uppercase tracking-widest mb-2">Email</div>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
              <input
                data-testid="admin-input-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-black border border-white/10 pl-10 pr-4 py-3 text-white focus:outline-none focus:border-[color:var(--gold)]"
              />
            </div>
          </label>
          <label className="block">
            <div className="text-[11px] font-semibold text-gray-400 uppercase tracking-widest mb-2">Mot de passe</div>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
              <input
                data-testid="admin-input-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-black border border-white/10 pl-10 pr-4 py-3 text-white focus:outline-none focus:border-[color:var(--gold)]"
              />
            </div>
          </label>
        </div>

        <button
          data-testid="admin-btn-login"
          disabled={busy}
          type="submit"
          className="btn-gold w-full mt-8"
        >
          {busy ? "Connexion..." : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
